import { Stack, Tooltip, Typography } from "@mui/material";
import { useMemo } from "react";
import type { WorkbookReport } from "../../../../../api/types/workbookRuns.types";

interface Props {
  report: WorkbookReport;
}
const WorkbookReportItemSheetName = ({ report }: Props) => {
  const worksheetNames = useMemo(() => {
    return [report.worksheetName, ...(report.additionalSheets?.map((sheet) => sheet.worksheetName) ?? [])];
  }, [report.worksheetName, report.additionalSheets]);

  if (worksheetNames.length > 1) {
    return (
      <Tooltip
        disableInteractive
        title={
          <Stack sx={{ gap: 0.5 }}>
            {worksheetNames.map((n) => (
              <Typography key={n} noWrap sx={{ fontSize: "10px", lineHeight: "14px" }}>
                {n}
              </Typography>
            ))}
          </Stack>
        }
      >
        <Typography sx={{ fontSize: "10px", lineHeight: "12px" }} noWrap>
          {`Multiple (${worksheetNames.length})`}
        </Typography>
      </Tooltip>
    );
  }
  return (
    <Typography sx={{ fontSize: "10px", lineHeight: "12px" }} noWrap>
      {report.worksheetName}
    </Typography>
  );
};

export default WorkbookReportItemSheetName;
